import { createSearchParams, useNavigate } from 'react-router-dom';

export function useNavigateSearch() {
  const navigate = useNavigate();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (pathname: string, params: any) => navigate({ pathname, search: `?${createSearchParams(params)}` });
}
